export default {
      id: "uspCard-buildYourChildFuture-usage",
      viewBox: "0 0 200 52",
      url: __webpack_public_path__ + "sprite.svg#uspCard-buildYourChildFuture",
      toString: function () {
        return this.url;
      }
    }